module.exports = __webpack_public_path__ + "static/img/school-0.1a57bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-0.png
// module id = Opiu
// module chunks = 1